import { ComparisonDatum } from 'ComponentLibrary/src/molecules/ComparisonChart/types'
import { decimalToLocalizedString } from 'ComponentLibrary/src/common/numbers'
import { joinDefinedStrings } from 'ComponentLibrary/src/common/strings'
import { Box } from '@mui/material'
import { Typography } from 'ComponentLibrary/src/atoms/typography'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

type ComparisonChartTooltipProps = { data: ComparisonDatum; formattedValue: string }

export const ComparisonChartTooltip = ({ data, formattedValue }: ComparisonChartTooltipProps) => {
    const displayValue = data.value >= 100 ? decimalToLocalizedString(data.value, true, undefined, undefined, data.locale) : formattedValue
    const displayValueWithUnit = joinDefinedStrings([displayValue, data.unit])

    return (
        <Box
            padding={`${tokens.SizingSpacing050} ${tokens.SizingSpacing150}`}
            bgcolor={tokens.ColorGraphNeutralDarker}
            borderRadius={tokens.SizingCornerS}
        >
            <Typography variant="bodyTextMedium" color={tokens.ColorTextInverse}>
                {data.label}: {displayValueWithUnit}
            </Typography>
        </Box>
    )
}
